import { pgTable, serial, integer, text, timestamp, unique } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";

export const vendorReviewsTable = pgTable(
  "vendor_reviews",
  {
    id: serial("id").primaryKey(),
    vendorId: integer("vendor_id").notNull(),
    buyerUserId: integer("buyer_user_id").notNull(),
    quoteRequestId: integer("quote_request_id").notNull(),
    rating: integer("rating").notNull(),
    comment: text("comment"),
    createdAt: timestamp("created_at").notNull().defaultNow(),
  },
  (t) => [
    unique("uq_review_per_quote").on(t.quoteRequestId),
  ],
);

export const insertVendorReviewSchema = createInsertSchema(vendorReviewsTable).omit({ id: true, createdAt: true });
export type InsertVendorReview = z.infer<typeof insertVendorReviewSchema>;
export type VendorReview = typeof vendorReviewsTable.$inferSelect;
